module.exports = __webpack_public_path__ + "media/ding.dae4643f.mp3";